﻿$.fn.dxCtrlFichier2VisuGoogleDrive = function custom_dxCtrlFichier2VisuGoogleDrive(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2visugoogledrive");
        this.instance = new cdxCtrlFichier2VisuGoogleDrive(this, option);
    }
    return this;
}

window.cdxCtrlFichier2VisuGoogleDrive = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dx = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        if (typeof option.bddCtrl.utiCourantParaJson.parametre_general.affichage_previ_doc_automatique == 'undefined' || !option.bddCtrl.utiCourantParaJson.parametre_general.affichage_previ_doc_automatique) {
            var $DivTot = $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;'/>").appendTo(container)
            var $DivInner = $("<div style='text-align:center;width:100%;'/>").appendTo($DivTot)
            $("<div>L'affichage de l'aperçu de ce document<br/>utilise le service <b>Google docs</b>.<br/>Pour afficher cette aperçu, vous allez donner l'accès à votre document<br/>à ce service le temps de l'affichage de l'aperçu.<br/><br/>Si votre document est confidentiel et que vous ne désirez pas le partager,<br/>n'utiliser pas ce service et choisissez de <a href='javascript:void(0)' class='telecharger'>télécharger</a> votre document sur votre ordinateur.</div>").appendTo($DivInner)
            $DivInner.find(".telecharger").on("click", function () { mDownLoadFile(option.bddCtrl, option.itemData.url) })
            $("<div style='margin-top:20px;'/>").appendTo($DivInner).dxCtrlButton({
                html: "Je comprends le risque<br/>Voir en prévisualisation",
                width: 280,
                height: 50,
                onClick: function (e) {
                    if (parametre.isLocalhost) mNotify("L'aperçu ne fonctionne pas en localhost.", "error", 6000)
                    if (dxChkCompris.option("value")) {
                        option.bddCtrl.utiCourantParaJson.parametre_general.affichage_previ_doc_automatique = true
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                    }
                    mRempli()
                }
            }).dxCtrlButton("instance");
            var $Table = $("<table style='display:inline-block;margin-top:20px;'/>").appendTo($DivInner)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
            var dxChkCompris = $("<div style=''/>").appendTo($Td).dxCtrlCheckBox({
                text: ""
            }).dxCtrlCheckBox("instance")
            var $Td = $("<td style='text-align:left;'/>J'ai compris, ne plus me prévenir<br/>charger les documents automatiquement à l'avenir</td>").appendTo($Tr)
        } else {
            mRempli()
        }
    }

    function mRempli() {
        container.empty()
        var jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()
        option.bddCtrl.mAjaxCall({ command: "copyfileexterne", url: option.itemData.url }, function (data) {
            if (data.url.startsWith("~")) data.url = data.url.substring(1);
            var fichier = new cFichier(option.bddCtrl, data.url)
            var isLoaded = false
                    $EleDoc = $("<iframe style='height:100%;width:100%;border-radius:3px;box-sizing:border-box;border:none;' class='dx-theme-background-color'/>")
                    $EleDoc.on("load", function () {
                        console.log("loaded")
                        jauge.mHide()
                        isLoaded = true
                    })
            switch (fichier.mGetExtension()) {
                case "odt": case "ods": case "odp":
                    $EleDoc.attr("src", "/viewerjs/#../" + encodeURIComponent(data.url) + "")
                    break;
                // ✅ Word
                case 'doc':
                case 'docx':
                case 'dot':
                case 'dotx':
                case 'rtf':

                // ✅ Excel
                case 'xls':
                case 'xlsx':
                case 'xlsb':
                case 'xlsm':
                case 'xlt':
                case 'xltx':

                // ✅ PowerPoint
                case 'ppt':
                case 'pptx':
                case 'pps':
                case 'ppsx':
                case 'pot':
                case 'potx':
                    // Microsoft Office Viewer
                    viewerUrl = "https://view.officeapps.live.com/op/embed.aspx?src=" + encodeURIComponent(document.URLRacine + data.url) + ""
                    $EleDoc.attr("src", viewerUrl)
                    break;
                case "pages": case "ai": case "tif": case "tiff": case "eps": case "ps": case "xps": case "zip":
                default:
                    // autres
                    $EleDoc.attr("src", "https://docs.google.com/viewer?embedded=true&url=" + encodeURIComponent(document.URLRacine + data.url) + "")
                    break;
            }
            $EleDoc.appendTo(container);
            var timeoutDelete = window.setTimeout(function () {
                if (!isLoaded) {
                    window.clearTimeout(timeoutDelete)
                    option.bddCtrl.mAjaxCall({ command: "deletefileexterne", url: data.url });
                    mRempli()
                }
            }, 15000)

            //supprime le fichier copier dans le répertoire externe (quand le contrôle est supprimé)
            var funcDeleteFileOnClose = function () {
                if (container && container.closest("body").length == 1) {
                    timerRemovePopup = window.setTimeout(function () { funcDeleteFileOnClose() }, 500);
                } else { //on a retiré le ctrl du dom
                    window.clearTimeout(timeoutDelete)
                    option.bddCtrl.mAjaxCall({ command: "deletefileexterne", url: data.url });
                }
            }
            var timeoutDelete = window.setTimeout(function () { funcDeleteFileOnClose(); }, 10000);
        });
    }

    this.element = function () { return container }

    mConstruit();
}